import { AxiosError } from 'axios';

export const errorHandler = (err: unknown): Error => {
  if (err instanceof AxiosError) {
    const status = err.response?.status;
    const dataMessage = err.response?.data?.message;
    const message = status ? `${status}: ${dataMessage || err.message}` : err.message;
    const error = new Error(message);
    error.cause = err;

    return error;
  }

  if (err instanceof Error) {
    return err;
  }

  return new Error(typeof err === 'string' ? err : 'Unknown error');
};
